const initTextsSlider = () => {
	const sections = document.querySelectorAll( 'section.slideshow-with-text' );

	if ( sections.length ) {
		Array.from( sections ).forEach( ( section ) => {
			const slider = section.querySelector( '.myTextSwiper' );
			const slides = slider.querySelectorAll( 'li.swiper-slide' );
			
			const userAgent = navigator.vendor;

			if ( userAgent === "Google Inc." ) {
				slides.forEach( item => {
					const markup = item.querySelector( 'div' );
					if ( markup && markup.childNodes.length === 2 ) {
						markup.classList.add( 'two-elements' );
					}
				})
            }

			new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 30,
				autoHeight: true,
				loop: true,
				navigation: {
					nextEl: ".text-swiper-button-next",
					prevEl: ".text-swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
			});	
		} )
	}
}

export {
	initTextsSlider,
};